import ControllerContainer from "../../components/Layout/ControllerContainer";
import { View } from "react-native";
import TouchableButton from "../../components/TouchableButton";
import ComponentThemeType from "../../models/ComponentTheme";
import ComponentTypeEnum from "../../models/ComponentTypeEnum";
import Image from "../../components/Image/Image";
import { Props } from "./models";
import {
	StyledButtonContainer,
	StyledController,
	StyledControllerButton,
	StyledControllerText,
	StyledControllerTextContainer,
	StyledText,
} from "./styled";

const Controller = (props: Props) => {
	return (
		<View>
			{/* @ts-ignore */}
			<ControllerContainer>
				{/* @ts-ignore */}
				<StyledController isTitle={props.isTitle} isShortClips={props.isShortClips}>
					{!props.isTitle && !props.isNotRedeem && (
						/* @ts-ignore */
						<StyledControllerButton>
							<TouchableButton componentTheme={ComponentThemeType.VinFast} type={ComponentTypeEnum.Secondary} onPress={props?.onPress}>
								{props?.data?.icon ? (
									/* @ts-ignore */
									<StyledButtonContainer>
										<Image source={{ uri: props?.data.icon }} width={56} height={56} />
										{/* @ts-ignore */}
										<StyledText>{props?.data.buttonText}</StyledText>
									</StyledButtonContainer>
								) : (
									props?.data?.buttonText
								)}
							</TouchableButton>
						</StyledControllerButton>
					)}

					{!props?.isTitle && props?.data?.textDescription && (
						/* @ts-ignore */
						<StyledControllerText>
							{/* @ts-ignores */}
							<StyledText>{props?.data.textDescription}</StyledText>
						</StyledControllerText>
					)}

					{props.isTitle && (
						/* @ts-ignore */
						<StyledControllerTextContainer isShortClips={props.isShortClips}>
							{/* @ts-ignore */}
							<StyledControllerText>
								{/* @ts-ignore */}
								<StyledText>{props.ribbonTitle}</StyledText>
							</StyledControllerText>
						</StyledControllerTextContainer>
					)}
				</StyledController>
			</ControllerContainer>
		</View>
	);
};

export default Controller;
